import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import SignupPending from "@/pages/SignupPending";
import Activate from "@/pages/Activate";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminCompanyProfile from "@/pages/admin/AdminCompanyProfile";
import AdminBilling from "@/pages/admin/AdminBilling";
import AdminBranding from "@/pages/admin/AdminBranding";
import AdminPortals from "@/pages/admin/AdminPortals";
import AdminRoles from "@/pages/admin/AdminRoles";
import AdminCustomFields from "@/pages/admin/AdminCustomFields";
import AdminIntegrations from "@/pages/admin/AdminIntegrations";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import PlatformDashboard from "@/pages/PlatformDashboard";

function App() {
  useEffect(() => {
    document.title = "TIS Tenant Platform";
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/pending" element={<SignupPending />} />
          <Route path="/activate" element={<Activate />} />
          <Route path="/login" element={<Login />} />

          <Route path="/admin" element={<ProtectedRoute><AdminOverview /></ProtectedRoute>} />
          <Route path="/admin/company" element={<ProtectedRoute><AdminCompanyProfile /></ProtectedRoute>} />
          <Route path="/admin/branding" element={<ProtectedRoute><AdminBranding /></ProtectedRoute>} />
          <Route path="/admin/portals" element={<ProtectedRoute><AdminPortals /></ProtectedRoute>} />
          <Route path="/admin/roles" element={<ProtectedRoute><AdminRoles /></ProtectedRoute>} />
          <Route path="/admin/custom-fields" element={<ProtectedRoute><AdminCustomFields /></ProtectedRoute>} />
          <Route path="/admin/integrations" element={<ProtectedRoute><AdminIntegrations /></ProtectedRoute>} />
          <Route path="/admin/billing" element={<ProtectedRoute><AdminBilling /></ProtectedRoute>} />
          <Route path="/admin/security" element={<ProtectedRoute><AdminSecurity /></ProtectedRoute>} />

          <Route path="/platform" element={<ProtectedRoute requireRole="P-SA"><PlatformDashboard /></ProtectedRoute>} />

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
